import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFAutocomplete, RHFRadioGroup, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

export default function FamilyRelationNewEditForm({ yesNoArr, relshnData }) {
  const { control, setValue, watch, resetField } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'empFamilyRel',
  });
  const handleAdd = () => {
    append({
      relSrno: 0,
      passNo: '',
      name: '',
      relationship: null,
      dob: null,
      isAlive: 'true',
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  return (
    <>
      <Box
        mt={4}
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        {/* <Typography variant="subtitle2" sx={{ mb: '10px' }}>
          Family Details:
        </Typography> */}
        <Box>
          <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
            Family Details:
          </Typography>
        </Box>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Member
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={2}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Typography variant="subtitle2" sx={{ color: 'primary', mb: 1 }}>
              Family Member {index + 1}:
            </Typography>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <RHFTextField name={`empFamilyRel[${index}].relSrno`} />
            </Box>
            <Box
              rowGap={1.5}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <RHFTextField
                name={`empFamilyRel[${index}].name`}
                label={
                  <div>
                    Family Member Full Name
                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              />
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empFamilyRel[${index}].relationship`}
                  placeholder="Relationship"
                  label={
                    <div>
                      Relationship<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={relshnData}
                  showPlusIcon
                  getOptionLabel={(option) => option?.masterName || ''}
                  renderOption={(props, option) => (
                    <li {...props} key={option?.masterId}>
                      {option?.masterName}
                    </li>
                  )}
                />
              </Stack>
              <Controller
                name={`empFamilyRel[${index}].dob`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label="Date of Birth"
                    value={field.value}
                    onChange={(newValue) => {
                      field.onChange(newValue);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!error,
                        helperText: error?.message,
                      },
                    }}
                    maxDate={new Date()}
                  />
                )}
              />
              <RHFTextField
                name={`empFamilyRel[${index}].passNo`}
                 label={
                  <div>
                    Passport Number
                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
                onWheel={(e) => e.target.blur()}
              />
              <Stack spacing={1}>
                <Box
                  rowGap={2}
                  columnGap={1}
                  display="grid"
                  gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: '1fr 2fr',
                  }}
                >
                  <Typography variant="subtitle2" mt={1}>
                    Is Alive:
                  </Typography>
                  <RHFRadioGroup
                    row
                    spacing={2}
                    name={`empFamilyRel[${index}].isAlive`}
                    options={yesNoArr}
                  />
                </Box>
              </Stack>
            </Box>
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems={{ xs: 'flex-end', md: 'center' }}
              justifyContent="flex-end"
            >
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
FamilyRelationNewEditForm.propTypes = {
  yesNoArr: PropTypes.array,
  relshnData: PropTypes.array,
};
